import mobileApp from "common/utils/mobile/app";
import { track } from "common/utils/mixpanel/tracker";
import "./brands-public-page-info.scss";

const $getShareButton = () => document.querySelector(".js-storefront-share");

const initShareButton = () => {
  const $shareButton = $getShareButton();
  const textData = `Check out our ${window.jiffy.brands.brandName} Store on Jiffy`;
  const shareData = {
    message: textData,
    text: textData,
    title: textData,
    url: window.location.href
  };

  if (!$shareButton) return;
  if (!window.MOBILE_APP && !("share" in navigator)) return;

  $shareButton.classList.remove("hidden");
  $shareButton.addEventListener("click", () => {
    if (window.MOBILE_APP) {
      mobileApp.mq.publish("share", shareData);
    } else {
      navigator.share(shareData);
    }

    track("brand_storefront_share_clicked", {
      brand_name: window?.jiffy?.brands?.brandName,
      slug: window?.jiffy?.brands?.currentSlug,
      storefront_link: window.location.href
    });
  });
};

export default initShareButton;
